import { Component, EventEmitter, Inject, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ButtonIconType } from '../../atoms/button/button.component';

export interface StepConfig {
  label: string;
  template: TemplateRef<any>;
  stepControl?: AbstractControl;
}

export interface ModalStepperData {
  title: string;
  steps: StepConfig[];
  lastStepButtonLabel?: string;
  isLinear?: boolean;
  lastStepButtonIcon?: ButtonIconType;
}

@Component({
  selector: 'molecule-modal-stepper',
  templateUrl: './modal-stepper.component.html',
  styleUrls: ['./modal-stepper.component.scss']
})
export class ModalStepperComponent {
  @Input() title: string = '';
  @Input() isLinear = true;
  @Input() lastStepButtonLabel: string = 'Finalizar';
  @Input() lastStepButtonIcon?: ButtonIconType;
  @Output() finalize = new EventEmitter<boolean>();
  @ViewChild('stepper') stepper!: MatStepper;

  public steps: StepConfig[] = [];

  constructor(
    private dialogRef: MatDialogRef<ModalStepperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalStepperData
  ) {
    this.title = data.title ?? '';
    this.isLinear = data.isLinear ?? true;
    this.steps = data.steps ?? [];
    this.lastStepButtonIcon = data.lastStepButtonIcon;
    this.lastStepButtonLabel = data.lastStepButtonLabel ?? this.lastStepButtonLabel;
  }

  get isLastStep(): boolean {
    if (!this.stepper || !this.stepper.steps) return false;
    return this.stepper.selectedIndex === this.stepper.steps.length - 1;
  }

  get nextButtonText(): string {
    return this.isLastStep ? this.lastStepButtonLabel : 'Siguiente';
  }

  // Avanza al siguiente paso o finaliza el proceso si es el último paso
  handleNext(): void {
    const currentStep = this.steps[this.stepper.selectedIndex];

    // Si el paso actual tiene un control de formulario y es inválido, no permite avanzar
    if (currentStep?.stepControl?.invalid) {
      currentStep.stepControl.markAllAsTouched();
      return;
    }

    if (this.isLastStep) {
      this.finalize.emit(true);
      return;
    }

    this.stepper.next();
  }

  // Retrocede al paso anterior
  handlePrevious(): void {
    this.stepper.previous();
  }

  onCloseModal(): void {
    this.dialogRef.close({ success: false });
  }
}
